import { Suspense } from 'react';
import { isNotFound } from '@tanstack/react-router';
import { usePortalCampaignQuery } from '@/lib/queries';
import { Image } from '../../-components/image';
import { NativeCarousel, NativeCarouselItem } from '@worldcoo/ui/components/native-carousel';

export function CampaignImageGallery(props: { campaignId: string }) {
	return (
		<Suspense fallback={null}>
			<SuspensedCampaignImageGallery campaignId={props.campaignId} />
		</Suspense>
	);
}

function SuspensedCampaignImageGallery(props: { campaignId: string }) {
	const campaign = usePortalCampaignQuery(props.campaignId);

	if (isNotFound(campaign)) return null;
	if (!campaign.data.carouselImages || campaign.data.carouselImages.length === 0) return null;

	return (
		<section className="w-full pb-6">
			<NativeCarousel
				className="gap-5"
				style={{
					paddingLeft: 'max(2.5rem, calc((100% - 1366px) / 2 + 2.5rem))',
					paddingRight: 'max(2.5rem, calc((100% - 1366px) / 2 + 2.5rem))',
				}}
			>
				{campaign.data.carouselImages.map((img, index) => (
					<NativeCarouselItem
						key={img.location}
						className="w-full basis-full sm:basis-[calc((100%-1.5rem)/2)] lg:basis-[calc((100%-2.5rem)/3)]"
					>
						<Image
							src={img.location}
							height={286}
							aspectRatio={413 / 286}
							className="w-full! rounded-2xl object-cover"
							alt={img.alt ?? `Campaign gallery ${index + 1}`}
							loading="lazy"
						/>
					</NativeCarouselItem>
				))}
			</NativeCarousel>
		</section>
	);
}
